import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const subCategories = `${REACT_APP_API_PREFIX}/${service}/subCategories`;

export function getSubCategories(filters) {
  const url = `${subCategories}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getSubCategoryById(id) {
  const url = `${subCategories}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateSubCategory(id, body) {
  const url = `${subCategories}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteSubCategory(id) {
  const url = `${subCategories}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createSubCategory(body) {
  const url = `${subCategories}`;
  return {
    method: POST,
    url,
    body,
  };
}
